module.exports = __webpack_public_path__ + "static/tari2-aabe25952eac565cbd96928ec7b740da.jpg";